import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card-body" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h6", { class: "heading-small text-muted mb-4" }, "Part Supplied", -1)
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-3" }
const _hoisted_5 = { class: "col-2 text-center" }
const _hoisted_6 = { class: "col-4" }
const _hoisted_7 = { class: "col-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_input = _resolveComponent("n-input")!
  const _component_n_input_number = _resolveComponent("n-input-number")!
  const _component_n_dynamic_input = _resolveComponent("n-dynamic-input")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(_component_n_dynamic_input, {
        value: _ctx.value,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
        "on-create": _ctx.onCreate,
        size: "large",
        disabled: _ctx.viewOnly
      }, {
        "create-button-default": _withCtx(() => [
          _createTextVNode(" Add Part ")
        ]),
        default: _withCtx(({ value }) => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_n_input, {
                value: value.part_number,
                "onUpdate:value": ($event: any) => ((value.part_number) = $event),
                disabled: _ctx.viewOnly,
                type: "text",
                size: "large",
                placeholder: "Part Number"
              }, null, 8, ["value", "onUpdate:value", "disabled"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_n_input_number, {
                value: value.quantity,
                "onUpdate:value": ($event: any) => ((value.quantity) = $event),
                disabled: _ctx.viewOnly,
                size: "large",
                "button-placement": "both",
                min: "1",
                placeholder: "1"
              }, null, 8, ["value", "onUpdate:value", "disabled"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_n_input, {
                value: value.description,
                "onUpdate:value": ($event: any) => ((value.description) = $event),
                disabled: _ctx.viewOnly,
                type: "text",
                size: "large",
                placeholder: "Description"
              }, null, 8, ["value", "onUpdate:value", "disabled"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_n_input, {
                value: value.remarks,
                "onUpdate:value": ($event: any) => ((value.remarks) = $event),
                disabled: _ctx.viewOnly,
                type: "text",
                size: "large",
                placeholder: "Remarks"
              }, null, 8, ["value", "onUpdate:value", "disabled"])
            ])
          ])
        ]),
        _: 1
      }, 8, ["value", "on-create", "disabled"])
    ])
  ]))
}